import { render } from "./Faqs.vue?vue&type=template&id=2b687fb2"
import script from "./Faqs.vue?vue&type=script&lang=js"
export * from "./Faqs.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import PageTitle from "@/components/PageTitle.vue";
import FaqList from "@/components/FaqList.vue";
script.components = Object.assign({}, { Breadcrumbs, PageTitle, FaqList }, script.components);